import { QBankStructureLevelCategory } from '@exam-management/graphql';

import type { LocationSchemaFormInput } from '../providers';

export type QuestionType = 'single' | 'item-set';

export const EMPTY_LOCATION: LocationSchemaFormInput = {
  CHAPTER: null,
  GROUP: null,
  PART: null,
  SUBJECT: null,
  SUB_TOPIC: null,
  TOPIC: null,
};

export const LOCATION_LEVEL_ORDER: (keyof LocationSchemaFormInput)[] = [
  QBankStructureLevelCategory.SubTopic,
  QBankStructureLevelCategory.Topic,
  QBankStructureLevelCategory.Chapter,
  QBankStructureLevelCategory.Group,
  QBankStructureLevelCategory.Subject,
  QBankStructureLevelCategory.Part,
];
